.cartButton {
    padding-left: calc(var(--bi-scale-2x) + var(--bi-scale-0-50x));
    padding-right: calc(var(--bi-scale-2x) + var(--bi-scale-0-50x));
}

.signedInConfirmation {
    padding: var(--bi-scale-4x);
    position: absolute;
    top: calc(var(--bi-layout-navbar-height) + var(--bi-scale-4x));
    right: 91px;
    opacity: 0;
    animation: fadeInAndOut 10s ease-in-out forwards;

    /* breakpoint for navbar */
    @media (width < 768px) {
        right: 84px;
    }

    h3 {
        font-size: 1.25rem;
        font-weight: 600;
    }

    p {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5rem;
    }
}

@keyframes fadeInAndOut {
    0% {
        opacity: 0;
    }
    5% {
        opacity: 1;
    }
    95% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
.cartDrawer {
    overflow-y: hidden;
    height: 100dvh;
    background-color: var(--bi-neutral-5);
    @media (width >= 1024px) {
        width: 712px;
    }
}

.closeButton {
    @media (width >= 768px) {
        right: var(--bi-scale-8x);
    }
}
.cartHeader {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-3x);
    color: var(--bi-neutral-90);
    background-color: var(--bi-basic-white);
    padding: var(--bi-scale-4x) var(--bi-scale-8x);
    @media (width < 768px) {
        padding: var(--bi-scale-4x);
    }
}
.cartItemCount {
    font-weight: 400;
    color: var(--bi-neutral-60);
}

.cartHeaderTitle {
    color: var(--bi-neutral-90);
    line-height: 1.5rem;
    font-size: var(--bi-scale-5x);
    font-weight: bold;
    font-family: museo-sans, arial, sans-serif;
}

.cartContent {
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    padding: 0 var(--bi-scale-8x);
    align-items: center;
    height: 100%;
    background-color: var(--bi-neutral-5);

    @media (width < 768px) {
        padding: 0 var(--bi-scale-4x);
    }
}

.emptyContentContainer {
    justify-content: center;
    text-align: center;
}

.cartItems {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: var(--bi-scale-4x);
}

.moreStudiesButton {
    align-self: center;
    margin-bottom: var(--bi-scale-9x);
    margin-top: var(--bi-scale-5x);
}

.cartFooter {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: var(--bi-scale-4x) var(--bi-scale-8x);
    margin: 0;
    background-color: var(--bi-basic-white);
    gap: var(--bi-scale-3x);

    @media (width < 768px) {
        padding: var(--bi-scale-4x);
    }
}

.emptyCart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--bi-scale-3x);

    @media (width < 768px) {
        padding: 0;
        max-width: 300px;
    }
}

.emptyCartHeading {
    font-weight: 700;
    font-size: 1.5rem;

    @media (width < 768px) {
        font-size: 1.25rem;
    }
}

.emptyCartLabel {
    font-size: 1rem;
    color: var(--bi-neutral-60);
    line-height: 1.25rem;
    font-weight: 400;
    margin-bottom: var(--bi-scale-3x);

    @media (width < 768px) {
        font-size: 0.875rem;
    }
}
